/**
 * Do not modify
 */
import Alpine from "alpinejs";
import focus from '@alpinejs/focus'
import Swiper from "swiper";
import { Navigation, A11y, Keyboard, Pagination } from "swiper/modules";

const swiperElems = document.querySelectorAll(".fluidbase-image-carousel");

const preloadNext = (swiper, n) => {
  swiper.slides
    .slice(swiper.activeIndex, swiper.activeIndex + n + 1)
    .map((slide) => slide.querySelector("img"))
    .forEach((s) => {
      if (s === null) {
        return;
      }
      s.setAttribute("loading", "eager");
    });
};

let on = {};

on.afterInit = (swiper) => {
  preloadNext(swiper, 1);
};

on.slideChange = (swiper) => {
  preloadNext(swiper, 1);
};

swiperElems.forEach((swiperElem) => {
  const hasPagination = "true" === swiperElem.dataset.pagination;
  const hasNavigation = "true" === swiperElem.dataset.navigation;
  const desktopSlides = swiperElem.dataset.slidesToShow
    ? parseInt(swiperElem.dataset.slidesToShow)
    : 3;

  const swiper = new Swiper(swiperElem, {
    modules: [Navigation, A11y, Keyboard, Pagination],
    enabled: true,
    autoplay: false,
    slidesPerView: 1,
    spaceBetween: 15,
    lazyPreloadPrevNext: 1,
    pagination: {
        enabled: hasPagination,
        el: ".swiper-pagination",
    },
    navigation: {
        enabled: hasNavigation,
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    a11y: {
      enabled: true,
    },
    on: on,
    lazy: true,
    keyboard: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: desktopSlides,
        spaceBetween: 15,
      },
    },
  });
});

Alpine.plugin(focus)

window.Alpine = Alpine;

Alpine.start();
